import { useEffect, useState } from "react";
import type { PromptMetric } from "@akhshy/types";
import { client } from "../../lib/api.ts";

/**
 * "Most reached for" strip — the prompts copied most often, honest usage data
 * backing the desk's thesis. Renders nothing until there's real data, so it
 * degrades quietly when the metrics table is still empty.
 */
export function MostReachedFor() {
  const [items, setItems] = useState<PromptMetric[]>([]);

  useEffect(() => {
    let alive = true;
    client.metrics
      .topPrompts(4)
      .then((r) => {
        if (alive) setItems(r.items.filter((m) => m.count > 0));
      })
      .catch(() => {
        /* strip is optional; ignore */
      });
    return () => {
      alive = false;
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="reached-strip" aria-label="Most reached for">
      <p className="reached-eyebrow">Most reached for</p>
      <ul className="reached-list">
        {items.map(({ prompt, count }) => (
          <li key={prompt.id} className="reached-chip">
            <span className="reached-use-case">{prompt.useCase}</span>
            <span className="reached-title">{prompt.title}</span>
            <span className="reached-count">
              {count} {count === 1 ? "copy" : "copies"}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
